module.exports = "<div><em>Account:</em> {{ level$ | async }} power level</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/power-planner/power-planner/src/app/page-main.module/account-level.component/account-level.component.html
// module id = ../../../../../src/app/page-main.module/account-level.component/account-level.component.html
// module chunks = main